import { render, staticRenderFns } from "./BitrixLoginModal.vue?vue&type=template&id=4b119c06&scoped=true"
import script from "./BitrixLoginModal.vue?vue&type=script&lang=js"
export * from "./BitrixLoginModal.vue?vue&type=script&lang=js"
import style0 from "./BitrixLoginModal.vue?vue&type=style&index=0&id=4b119c06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b119c06",
  null
  
)

export default component.exports